<div class="flex-row-container m-t5">
  <span class="flex-1 m-t10 m-l15 blueText16 B">Accounts & Savings</span>
  <button mat-stroked-button class="m-r10" color="primary" [ngClass]="isDataChanged?'highlight-bg':''" (click)="saveSelectedAccounts()">Save</button>
  <!-- <button [matMenuTriggerFor]="addaccountmenu" class="m-r10 font14" mat-stroked-button  disabled color="primary">Add Account</button> -->
  <div class="flex-row-container">
    <button  mat-raised-button color="primary" [matMenuTriggerFor]="clientmenu" (click)="$event.stopPropagation();">
      Add Hypothetical Account for
    </button>
    <mat-icon class="pointer m-lr10 m-t7" style="font-size: 20px;" matTooltip="Refresh" (click)="refreshEA();$event.stopPropagation();">refresh</mat-icon>  
  </div>
</div>
<div class="flex-row-center m-t8">
  <mat-divider class="divider" style="width: 99%"></mat-divider>
</div>
<div class="summary-panel-container" (click)="$event.stopPropagation();">
  <mat-card *ngFor="let acc of accounts" class="summary-item pointer" [matBadge]="acc.isIncluded?'check':''" [style.background]="acc.isIncluded?'#D5D7F2':''" (click)="selectAccount(acc.id)">
    <mat-card-content> 
        <div class="flex-row-container">
          <div class="flex-col-container wd-45">
            <span class="font18 text-truncate">
              {{(acc.CustodianType==='Internal' && acc.gfoCustodyAccount)?acc.gfoCustodyAccount:
              (acc.CustodianType==='Internal'?acc.id : acc.accountNickname)}}       
              <!-- <div *ngIf="acc.CustodianType==='HypoEA'" class="flex-col-container">
                <span  class="text-truncate" matTooltip="HYPOTHETICAL">
                  {{acc.accountNickname}}      
                </span>                
              </div>   -->
            </span>
            <span class="blueText15 text-truncate">
              {{acc.CustodianType==='External'?acc.CustodyAccount : 
              (acc.CustodianType==='Internal' && acc.gfoCustodyAccount && acc.CustodyAccount?acc.CustodyAccount:'')}} </span>
            <span class="blueText15 text-truncate">{{acc.CustodianType==='External'?acc.CustodianName : ''}}</span>              
            <span class="blueText18 text-truncate">{{acc.LegalEntityName}}</span>
            <span class="font14 gray-text text-truncate">{{acc.registrationDesc}}</span>            
            <span class="font14" [style.color]="acc.taxStatusColor">{{acc.taxstatus  | uppercase}}</span>            
          </div>
          <div class="flex-col-end m-l25 wd-55">            
            <span class="blueText20">{{acc.AccountTotal | currency:'USD': 'symbol' : '1.0-0'}}</span>
            <span *ngIf="acc.cContribution" class="font14">Savings: <span class="blueText16">{{acc.cContribution | currency:'USD': 'symbol' : '1.0-0'}}</span><span class="font14">/yr</span></span>
            <!-- <span *ngIf="acc.cContribution" class="font14 gray-text" style="margin-top: -5px">per year</span>             -->
            <!-- <span class="font14" *ngIf="acc.cContribution">Savings: <span class="blueText14">{{acc.cContribution | currency:'USD': 'symbol' : '1.0-0'}}/yr</span></span> -->
            <!-- <span class="font14" *ngIf="acc.eContribution">Emp. Contrib: <span class="blueText14">{{acc.eContribution | currency:'USD': 'symbol' : '1.0-0'}}/yr</span></span> -->
            
            <div class="flex-row-container">
              <mat-icon class="font20 m-l10" (click)="editAccount(acc.id);$event.stopPropagation();"  matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Edit Savings">edit</mat-icon>              
              <!-- <mat-icon class="font30" *ngIf="acc.isIncluded">check</mat-icon>               -->
            </div>        
            <div *ngIf="acc.CustodianType==='HypoEA'" class="flex-row-container font11 hy p-t2" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Edit Hypothetical Account" (click)="editHypotheticalAccount(acc.id, acc.LegalEntityID);$event.stopPropagation();">              
              <span class="p-l4 ">HYPOTHETICAL</span>
              <mat-icon class="m-l3 font16 pointer">edit</mat-icon>              
              <sup class="font11 superSummaryIcon"><mat-icon class="m-l5 font10">launch</mat-icon></sup>
            </div>

            
            <!-- <span class="blueText14">LegalEntityName</span>
            <span class="font14 gray-text text-truncate">Individual</span> -->
          </div>          
          <!-- <div class="m-l15 flex-col-container">
            <span class="font16"></span>
            <span class="font16">Managed</span>
            <span class="blueText14">Advisor Model</span>
            <span class="font14 gray-text text-truncate">Global Equity Model</span>
          </div> -->
        </div>
        <!-- <div class="m-t10 flex-row-container">
          <div class="flex-col-container">
            <span class="font16">TAX-DEFERRED</span>            
          </div>
          <div class="m-l15  flex-col-container">
            <span class="font16">$869,596</span>            
          </div>
        </div> -->
        <!-- <div class="flex-row-center">          
        </div> -->
    </mat-card-content>
  </mat-card>
</div>


<mat-menu #addaccountmenu="matMenu">
  <ng-container *ngFor="let item of accountTypeMenuItems">
    <button *ngIf="item.type!=='Joint'" class="font14" mat-menu-item [matMenuTriggerFor]="sub_menu"> {{item.displayClientname}}</button>
    <button *ngIf="item.type==='Joint'" class="font14" mat-menu-item (click)="addAccounts('OT', '0')"> {{item.displayClientname}}</button>
    <mat-menu #sub_menu="matMenu">
         <button *ngFor="let subItem of item.subMenuItems" class="font14" mat-menu-item (click)="addIncome(subItem.code, subItem.clientid)" >{{ subItem.value }}</button>
    </mat-menu>
  </ng-container> 
</mat-menu>
<mat-menu #clientmenu="matMenu">
  <div class="" *ngFor="let client of clientMenuItems">
    <button class="font14" mat-menu-item (click)="addHypotheticalAccount(client.clientid)"> {{client.displayClientname}}<mat-icon class="m-l5 m-t7 font16">launch</mat-icon></button>    
  </div> 
</mat-menu>